import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Reassign Candidate|Identities|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPToolsReassignCandidateIdentities';
export type SPToolsReassignCandidateIdentitiesLocNames =
	| `${LocNameStart}LabelId`
	| `${LocNameStart}LabelDP`
	| `${LocNameStart}LabelCreated`
	| `${LocNameStart}LabelPreferred`;

export const spToolsReassignCandidateIdentitiesLocs: LocDefs<SPToolsReassignCandidateIdentitiesLocNames> =
	{
		SPToolsReassignCandidateIdentitiesLabelId: {
			defaultValue: 'ID',
			description: 'Label for the ID column',
			displayPath: `${pathStart}ID`,
			displayType: 'Label',
			legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.IdentityID',
			...sharedProperties,
		},
		SPToolsReassignCandidateIdentitiesLabelDP: {
			defaultValue: 'Data Provider',
			description: 'Label for the Data Provider column',
			displayPath: `${pathStart}DP`,
			displayType: 'Label',
			legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.IdentityDP',
			...sharedProperties,
		},
		SPToolsReassignCandidateIdentitiesLabelCreated: {
			defaultValue: 'Created',
			description: 'Label for the Created column',
			displayPath: `${pathStart}Created`,
			displayType: 'Label',
			legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.IdentityCreated',
			...sharedProperties,
		},
		SPToolsReassignCandidateIdentitiesLabelPreferred: {
			defaultValue: 'Is Preferred',
			description: 'Label for the Is Preferred column',
			displayPath: `${pathStart}Preferred`,
			displayType: 'Label',
			legacyName: 'Core/Tools.ReassignCandidateData.ColumnHeading.IdentityPreferred',
			...sharedProperties,
		},
	};

export type SPToolsReassignCandidateIdentitiesLocType =
	LocMap<SPToolsReassignCandidateIdentitiesLocNames>;
